// extracted by mini-css-extract-plugin
export default {"delete-modal":"delete_delete-modal__sYbew","delete-modal__body":"delete_delete-modal__body__HyPbN"};